import loadable from '@loadable/component';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';
import {
  ACTION_TYPE,
  COMPONENT_NAME,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';

import logMiniEventHelper from '../../../mini-event/logMiniEventHelper';
import withErrorBoundary from '../../ErrorBoundary';
import { useMBDContext } from '../../common/MBD/useMBDContext';
import CrossLink from '../CrossLink/CrossLink';

import type { SeoCrossLinksProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './CrossLinks.module.scss';

const IntersectionObserverWrapper = loadable(
  () => import('../../IntersectionObserverWrapper/IntersectionObserverWrapper'),
);

const CrossLinks = (props: SeoCrossLinksProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!props?.links?.length) {
    return null;
  }

  return (
    <div
      className={STYLES.CrossLinks}
      id="seo-cross-links-root"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      {props?.title && (
        <div className={STYLES.CrossLinks__header}>
          <BpkSectionHeader
            title={props.title}
            description={props?.subtitle || ''}
          />
        </div>
      )}
      <ul className={STYLES.CrossLinks__ul}>
        {props.links.map((link, index: number) => (
          <CrossLink
            key={Object.values(link).join('-')}
            {...link}
            index={index}
          />
        ))}
      </ul>
    </div>
  );
};

const CrossLinksWrapper = (props: SeoCrossLinksProps) => (
  <IntersectionObserverWrapper
    onElementSeen={() =>
      logMiniEventHelper({
        action_type: ACTION_TYPE.COMPONENT_VISIBLE,
        component_name: COMPONENT_NAME.SEO_CROSS_LINK,
      })
    }
  >
    <CrossLinks {...props} />
  </IntersectionObserverWrapper>
);

const CrossLinksWithErrorBoundary = withErrorBoundary(
  CrossLinksWrapper,
  'cross-links-component',
);

export default CrossLinksWithErrorBoundary;
